import { Button, ButtonProps } from "antd";

import styles from "./index.module.less";

export default function HBButton({ className, shape, ...props }: ButtonProps) {
  return (
    <Button
      {...props}
      className={`${styles.HBButton} ${className} ${
        shape === "circle" ? styles.circle : ""
      }`}
      shape={shape}
    />
  );
}
